import React, { createContext, useEffect, useState } from 'react'
import Ticket from './Ticket'
import { useParams } from 'react-router-dom'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { queryClient as qc } from 'keys'
import { getTicketFetch, getTicketMessagesFetch } from 'store/middlewares/tickets.crud'

const TicketPage = (props) => {
    const params = useParams()
    const [message, setMessage] = useState('')
    const [image, setImage] = useState(null)
    const [messageId, setMessageId] = useState(null)
    const [openMessageBox, setOpenMessageBox] = useState(false)
    const ticketID = params.ticketID
    const queryClient = useQueryClient()

    const ticket = useQuery({
        queryKey: [qc.ticket, ticketID],
        queryFn: async () => {
            const { data } = await getTicketFetch({ id: ticketID })
            return data
        },
    })

    const ticketMessages = useQuery({
        queryKey: [qc.ticketMessages, ticketID],
        queryFn: async () => {
            const { data } = await getTicketMessagesFetch({ id: ticketID })
            return data
        }
    })

    const commonValue = {
        ticket,
        ticketMessages,
        message, setMessage,
        image, setImage,
        openMessageBox, setOpenMessageBox,
        messageId, setMessageId
    }

    return (
        <TicketContext.Provider value={commonValue}>
            <Ticket {...props} />
        </TicketContext.Provider>
    )

}
export const TicketContext = createContext()
export default TicketPage